import React, { Component } from 'react';

import WorkerInfoApi from '../../services/workers/workerInfo/WorkerInfoApi';
import WorkerInfoService from '../../services/workers/workerInfo/WorkerInfoService';

import Information from './common/Information';
import Confirmation from './common/Confirmation';
import { DeleteWorkersTable } from '../tables/DeleteWorkersTable';
import { messageUtility } from '../../utilities/messageUtility';

export class DeleteWorkersConfirmDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: '',
      visibleDialogFlag: false,
      errorMessage: '',
    };

    this.isRequestingFlag = false;

    this.handleVisibleDialog = this.handleVisibleDialog.bind(this);
  }

  submit() {
    if (this.isRequestingFlag) {
      return;
    }
    this.isRequestingFlag = true;
    WorkerInfoApi.deleteWorker(
      this.props.companyId,
      WorkerInfoService.createDeleteWorkerParam(this.props.workers)
    ).then(response => {
      if (!response.result) {
        const data = response.data || {};
        const entities = data.entities || {};
        const {
          has_check_in_out_log,
          has_registered_worker_in_greenfile,
        } = entities;
        let messageError = response.message;
        const baseMessage =
          'に登録があるため作業員の削除に失敗しました。\n' +
          '今後、対象の作業員データが不要な場合にはステータスを「退職」に変更してください。\n' +
          '作業員一覧でステータスの「在籍」をクリックすることで「退職」に変更できます。';
        if (has_check_in_out_log && has_registered_worker_in_greenfile) {
          messageError = `入退場実績や労務安全書類${baseMessage}`;
        } else if (has_check_in_out_log) {
          messageError = `入退場実績${baseMessage}`;
        } else if (has_registered_worker_in_greenfile) {
          messageError = `労務安全書類${baseMessage}`;
        }
        return this.showErrorDialog(
          has_check_in_out_log || has_registered_worker_in_greenfile
            ? messageUtility.getMessage('E-000-167-02')
            : '',
          messageError
        );
      } else {
        this.props.submit();
      }
    }).finally(() => {
      this.isRequestingFlag = false;
    });
  }

  /**
   * @description ダイアログ表示
   * @param title
   * @param message
   */
  showErrorDialog(title, message) {
    this.handleVisibleDialog();
    this.setState({ title, errorMessage: message });
  }

  /**
   * 表示されているモーダルのバックグラウンドのスクロールトグル
   */
  toggleBackgroundScroll() {
    const scrollBackground = document.getElementById('infinityscroll-target');
    if (!scrollBackground) {
      return;
    }
    const anyModalDisplayed =
      document.querySelector('#root > .modal.show') !== null;
    scrollBackground.style.overflow = anyModalDisplayed ? 'hidden' : 'auto';
  }

  componentWillUnmount() {
    this.toggleBackgroundScroll();
  }

  /**
   * @description ダイアログ開閉設定
   */
  handleVisibleDialog() {
    this.setState({ visibleDialogFlag: !this.state.visibleDialogFlag });
  }

  /**
   * @description ダイアログ設定
   * @param title
   * @param message
   */
  getAlertModalForm(title, message) {
    const isDialogWorkersFailed = !!title;

    return (
      <Information
        title={title}
        message={message}
        buttonText={messageUtility.getMessage(
            isDialogWorkersFailed ? 'I-000-017' : 'I-000-011'
        )}
        visible={this.state.visibleDialogFlag}
        onClose={() => {
          this.handleVisibleDialog();
          this.props.submit();
        }}
        rootClassName={isDialogWorkersFailed ? 'dialog--wide dialog--workers-failed' : ''}
        multilineText={isDialogWorkersFailed}
      />
    );
  }

  generateDialogContent = () => {
    return (
      <React.Fragment>
        <div>
          <div className='DeleteWorkersDialog__subheader'>
            <p>{messageUtility.getMessage('W-002-005-01')}</p>
            <p>{messageUtility.getMessage('W-002-005-02')}</p>
          </div>
        </div>

        <div className='DeleteWorkersDialog__wrap-table'>
          <DeleteWorkersTable workers={this.props.workers} />
        </div>

        {this.getAlertModalForm(this.state.title, this.state.errorMessage)}
      </React.Fragment>
    );
  };

  render() {
    return (
      <Confirmation
        visible={this.props.show}
        title='削除確認'
        rootClassName={'DeleteWorkersDialog'}
        message={this.generateDialogContent()}
        cancelButtonText={messageUtility.getMessage('I-000-008')}
        confirmButtonText={messageUtility.getMessage('I-000-018')}
        isNegative={true}
        onConfirm={() => {
          this.submit();
        }}
        onCancel={() => {
          this.props.back();
        }}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modals/DeleteWorkersConfirmDialog.jsx